export default {
	READ_WRITE_DELETE: 'READ_WRITE_DELETE',
	READ_ONLY: 'READ_ONLY'
};
